<template>
    <div class="kanban">
        
        <div class="header">
            <div class="title" contenteditable>{{title}}</div>
            <div class="settings-btn --header" @click="addColumn()"></div>
        </div>

        <div class="columns" :class="columns_cls">
            <div class="column" v-for="(tasklist, tasklist_i) in tasklists">
                <div class="column-header" v-if="tasklists.length > 1">
                    <div class="column-title" contenteditable>{{tasklist.title}}</div>
                    <div class="settings-btn --column" @click="removeColumn(tasklist_i)"></div>
                </div>
                <div class="cards">
                    <div class="card" v-for="(task, task_i) in tasks" v-if="task.col_index == tasklist_i">
                        <div class="card-title" contenteditable>Task title</div>
                        <div class="card-excerpt" contenteditable>{{task.text}}</div>
                        <div class="settings-btn --card" @click="removeTask(task_i)"></div>
                    </div>
                    <div class="new-card-btn" @click="addTask(tasklist_i)">Add</div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        title: { type:String, default(){ return 'Tasks' } },
    },

    data(){return{

        tasklists: [
            { title: 'Todo' },
            { title: 'Doing' },
            { title: 'Done' },
        ],

        tasks: [],

    }},

    computed: {    

        columns_cls(){
            var cls = {}
            cls['count-'+this.tasklists.length] = true
            return cls
        },
        
    },

    mounted() {
        
        //this.tasks = this.$store.state.db.tasks
        this.tasks = []

    },

    methods: {
    
        addTask(tasklist_i) {
            // actually, here we should just emit an event so the parent component can do something actually useful
            // this here is just for dummy demo
            this.tasks.push({
                col_index: tasklist_i,
                text: 'New task',
            })
        },

        // just for demo
        removeTask(task_i){
            this.tasks.splice(task_i,1)
        },
    
        removeColumn(tasklist_i) {
            this.tasklists.splice(tasklist_i,1)
        },

        addColumn(tasklist_i) {
           this.tasklists.push({
               title: 'New column'
           }) 
        },

    },

    beforeDestroy() {
        
    },
}
</script>


// WEBPACK FOOTER //
// Kanban.vue?d4de491c